import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export function LeaOrb({ size = 40, className = "" }) {
  return (
    <motion.div
      data-testid="lea-orb"
      className={`lea-orb rounded-full shrink-0 ${className}`}
      style={{ width: size, height: size }}
      animate={{ scale: [1, 1.06, 1], rotate: [0, 8, 0] }}
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
    />
  );
}

export function LeaBadge() {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2.5">
      <LeaOrb size={28} />
      <div className="leading-tight">
        <p className="text-sm font-semibold font-display">{t("common.assistant")}</p>
        <p className="text-[11px] text-muted-foreground">{t("dashboard.leaRole")}</p>
      </div>
    </div>
  );
}
